export const tokens = {
  colors: {
    primary: {
      light: '#3b82f6',
      DEFAULT: '#2563eb',
      dark: '#1d4ed8',
      foreground: '#ffffff',
    },
    secondary: {
      light: '#a855f7',
      DEFAULT: '#7c3aed',
      dark: '#6d28d9',
      foreground: '#ffffff',
    },
    background: {
      light: '#f8fafc',
      dark: '#030712',
    },
    foreground: {
      light: '#0f172a',
      dark: '#f9fafb',
    },
    surface: {
      light: '#ffffff',
      dark: '#111827',
      border: '#e2e8f0',
      borderDark: '#374151',
    },
    muted: {
      light: '#f1f5f9',
      dark: '#1f2937',
      text: '#64748b',
      textDark: '#9ca3af',
    }
  },
  typography: {
    fontSans: "'Inter', system-ui, -apple-system, sans-serif",
    fontDisplay: "'Outfit', sans-serif",
  },
  transitions: {
    slow: 'all 500ms cubic-bezier(0.4, 0, 0.2, 1)',
    default: 'all 300ms cubic-bezier(0.4, 0, 0.2, 1)',
    fast: 'all 150ms cubic-bezier(0.4, 0, 0.2, 1)',
  }
};
